<template>
  <div v-if="props.assignee" class="flex space-x-2 leading-[0.9rem]">
    <user-avatar
      v-if="props.assignee && props.showAvatar"
      :user="props.assignee"
    />
    <div v-if="props.assignee && props.showFullname" class="leading-6">
      {{ props.assignee.fullname }}
    </div>
  </div>
</template>
<script setup>
import UserAvatar from "@/Tailwind/Components/UserAvatar";
import { defineProps } from "vue";

const props = defineProps({
  assignee: Object,
  showAvatar: {
    type: Boolean,
    required: false,
    default: true,
  },
  showFullname: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
